import { create } from "zustand";

export const useApplicationTrackingStore = create((set, get) => ({
  // State
  applicationTrackings: [],
  loading: false,
  error: null,
  selectedApplication: null,
  searchQuery: "",
  filters: {},

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },

  // Modal / UI states
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  applicationToDelete: null,
  isDetailDialogOpen: false,
  applicationToView: null,

  // Basic Setters
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setApplicationTrackings: (applicationTrackings) => set({ applicationTrackings }),
  setSelectedApplication: (application) => set({ selectedApplication: application }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPaginationData: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      currentPage: data.page || data.currentPage || state.paginationData.currentPage,
      itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
      totalItems: data.total || data.totalItems || state.paginationData.totalItems,
      totalPages: data.totalPages || state.paginationData.totalPages,
    }
  })),

  // UI Flow Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedApplication: null,
    error: null
  }),

  openEditForm: (application) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedApplication: application,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedApplication: null,
    error: null
  }),

  openDeleteDialog: (application) => set({
    isDeleteDialogOpen: true,
    applicationToDelete: application,
    error: null
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    applicationToDelete: null,
    error: null
  }),

  openDetailDialog: (application) => set({
    isDetailDialogOpen: true,
    applicationToView: application,
    error: null
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    applicationToView: null,
    error: null
  }),

}));
